export function apiErrorMessage(error, fallback = 'Não foi possível concluir a operação.') {
  const data = error && error.response ? error.response.data : null

  if (!data) return fallback
  if (typeof data === 'string') return data

  if (typeof data.message === 'string' && data.message !== 'Server Error') {
    return data.message
  }

  const errors = data.errors || (typeof data.message === 'undefined' ? data : null)

  if (errors && typeof errors === 'object') {
    const first = Object.keys(errors)[0]

    if (first) {
      const value = errors[first]
      return Array.isArray(value) ? value[0] : String(value)
    }
  }

  return fallback
}

function flattenMessages(source) {
  const items = []

  Object.keys(source).forEach(key => {
    const value = source[key]
    const texts = Array.isArray(value) ? value : [value]

    texts.forEach(text => {
      if (text !== null && text !== undefined && typeof text !== 'object') {
        items.push(String(text))
      }
    })
  })

  return items
}

function messagesToHtml(items, fallback) {
  if (!items.length) return typeof fallback === 'string' ? fallback : ''
  if (items.length === 1) return items[0]

  return `<ul>${items.map(text => `<li>${text}</li>`).join('')}</ul>`
}

export function errorBodyToHtml(body) {
  if (body === null || body === undefined) return ''
  if (typeof body === 'string') return body
  if (typeof body !== 'object') return String(body)

  if (body.errors && typeof body.errors === 'object') {
    return messagesToHtml(flattenMessages(body.errors), body.message)
  }

  if (typeof body.message === 'string') return body.message

  return messagesToHtml(flattenMessages(body), body.message)
}
